export default "__VITE_ASSET__a__sA6p9__"